import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ArquivoCreateDto } from '@core/dto/arquivo/arquivo-create.dto';
import { SweetalertCustom } from '../../utils/sweetalert-custom';
import { Util } from '../../utils/util';

@Component({
  selector: 'app-upload-photo',
  templateUrl: './upload-photo.component.html',
  styleUrls: ['./upload-photo.component.scss'],
})
export class UploadPhotoComponent {
  @Input() form: FormGroup;
  @Input() name: string;
  @Input() submitText = 'Selecionar foto';
  @Input() imgAlt = 'Imagem de Perfil';
  @Input() id: string = null;
  @Input() accept = '.jpg, .jpeg, .png';
  @Input() infoText: string;
  maxFileSize = 10 * 1024 * 1024;  //10MB

  isFirstLoad = true;
  acao = 'NOTHING';
  file: any;

  @ViewChild('inputPhoto') inputRef;


  constructor(private readonly domSanitizer: DomSanitizer) {}

  get formControl() {
    return this.form?.get(this.name);
  }

  get hasImage(): boolean {
    return !!this.imgSource;
  }

  get disabled(): boolean {
    return this.formControl?.disabled;
  }

  async onSelectFile(event) {
    if (this.disabled) { return; }

    this.file = (event.target as HTMLInputElement).files[0];

    if (!this.file) {
      this.clear();
      return;
    }
    const extensaoArquivo = '.' + this.file.name.split('.').pop().toLowerCase();
    const formatosPermitidos = this.accept.replace(/\s/g, '').split(',');
    const formatosConcatenados = Util.replaceLast(formatosPermitidos.join(', ').replace(/\./g, '').toUpperCase(), ',', ' ou ');

    if (!formatosPermitidos.includes(extensaoArquivo)) {
      SweetalertCustom.newShowAlertConfirm('error', 'Atenção!', `Formato inválido! Selecione uma imagem nos formatos ${formatosConcatenados}.`, 'Ok');
      this.clear();
      return;
    }

    if (this.file.size > this.maxFileSize) {
      SweetalertCustom.newShowAlertConfirm('warning', 'Atenção!', 'A imagem excede o tamanho máximo permitido de 10 MB. Por favor, selecione outra foto.')
      return;
    }

    const base64 = await this.getBase64FromFile(this.file);
    const arquivoDto = new ArquivoCreateDto({
      id: this.id,
      base64,
      extensao: '.' + this.file.type.split('/')[1],
      acao: this.id ? 'EDIT' : 'CAD',
      nome: this.file.name.split('.')[0],
    });
    this.formControl.setValue(arquivoDto);
  }

  get imgSource() {
    // Safe: imagem é gerada localmente via FileReader e não vem de fontes externas
    return this.formControl.value ? this.domSanitizer.bypassSecurityTrustUrl(`data:image/jpeg;base64, ${this.formControl.value?.base64}`) : '';
  }

  async getBase64FromFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () =>  resolve((reader.result as string).split(';base64,').pop());
      reader.onerror = () => reject(new Error(`Erro na leitura do arquivo: ${reader.error?.message || 'Erro desconhecido na leitura do arquivo'}`));
    });
  }

  clear() {
    this.formControl.setValue(null);
    this.file = null;
    this.inputRef.nativeElement.value = '';
  }
}
